import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { Container } from "react-bootstrap";
import Header2 from "../../components/Header2";
import axios from "axios";
import { USER_BASE_URL, CHANGEPASSWORD } from "../../API";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
function ChangePassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const navigate = useNavigate()
  const { register, handleSubmit, formState: { errors }, watch } = useForm();
  const watchpassword = watch('password')
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };
  async function onSubmit(data) {
    try {
      const access_token = localStorage.getItem('userToken')
      const response = await axios.put(USER_BASE_URL + CHANGEPASSWORD, {
        old_password: data.oldPassword,
        password: data.password,
        confirm_password: data.confirmPassword,
        language: 'ENGLISH'
      }, {
        headers: {
          token: access_token
        }
      })
      toast.success("Password Changed Successfully.")
      navigate('/profile')
    } catch (error) {
      let err = ''
      if (error.response.data.error_message) { err = error.response.data.error_message; }
      else {
        err = error.response.data.error_description;
      }
      console.log(error)
      toast.error(err)
    }
  }

  return (
    <>
      <div className="comm_page_outer2">
        <Container>
          <Header2 />
          <div className="comm_inner_page_layout">
            <section className="comm_form_border_box_row">
              <div className="comm_border_box">
                <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md={6}>
                      <Form.Group
                        controlId="formGridPassword"
                        className="comn-class-inputs marg-b-20"
                      >
                        <Form.Label>Current Password *</Form.Label>
                        <div class="cstPassGroup">
                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Your Current Password" autoFocus
                            {...register("oldPassword", { required: true })}
                          />
                          {errors.oldPassword && <span className='error'>Please enter current password.</span>}
                          <div
                            onClick={togglePasswordVisibility}
                            className="eyeToggleBtn"
                          >
                            {showPassword ? (
                              <RiEyeLine />
                            ) : (
                              <RiEyeOffLine />
                            )}
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group
                        controlId="formGridEmail"
                        className="comn-class-inputs marg-b-20"
                      >
                        <Form.Label>New Password *</Form.Label>
                        <div class="cstPassGroup">
                          <Form.Control type={showPassword1 ? 'text' : 'password'} placeholder="Enter Your Password"  {...register('password', {
                            required: true,
                            pattern: {
                              value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&_])[A-Za-z\d@$!%*?#&_]{8,}$/,
                              message: "New password must be at least 8 characters long with uppercase, lowercase, number, special character, and no spaces.                                ",
                            },
                          })} />
                          <div onClick={togglePasswordVisibility1} className="eyeToggleBtn">
                            {showPassword1 ? (
                              <RiEyeLine />
                            ) : (
                              <RiEyeOffLine />
                            )}
                          </div>
                          {errors.password && <span className="error">{errors.password.message || "Please enter new password."}</span>}

                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group
                        controlId="formGridEmail"
                        className="comn-class-inputs marg-b-20"
                      >
                        <Form.Label>Confirm New Password *</Form.Label>
                        <div class="cstPassGroup">
                          <Form.Control
                            type={showPassword2 ? "text" : "password"}
                            placeholder="Confirm New Password"
                            {...register("confirmPassword", { required: "Please enter confirm new password.", validate: value => value === watchpassword || "New password and confirm new password must be the same." })}
                          />
                          {errors.confirmPassword && <span className='error'>{errors.confirmPassword.message}</span>}
                          <div
                            onClick={togglePasswordVisibility2}
                            className="eyeToggleBtn"
                          >
                            {showPassword2 ? (
                              <RiEyeLine />
                            ) : (
                              <RiEyeOffLine />
                            )}
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="dash-pair-btns-comn comm_form_same_sz_btns d-flex align-items-center gap-3 mt-3">
                    <button className="main-btn" type="submit" >
                      Update
                    </button>
                    <Link to="/profile" className="main-outline-btn cancel">
                      cancel
                    </Link>
                  </div>
                </Form>
              </div>
            </section>
          </div>
        </Container >
      </div >
    </>
  );
}
export default ChangePassword;
